import React, { useContext } from 'react';
import { Clickable } from 'src/components/clickable';
import { UserAvatar } from 'src/components/user-avatar';
import { AppContext } from 'src/components/app-context';
import * as S from './styles';

type Props = {
  avatar: string;
  className?: string;
  displayName: string;
  link?: string | null;
  size: number;
  hideExpertIcon?: boolean;
};

const ExpertAvatar = ({
  avatar,
  className,
  displayName,
  link,
  size,
  hideExpertIcon,
}: Props) => {
  const { renderMode, linkTo } = useContext(AppContext);
  const Wrapper = ({
    renderWrapper,
    wrapper,
    children,
  }: {
    renderWrapper: boolean;
    wrapper: (children: React.ReactElement) => React.ReactElement;
    children: React.ReactElement;
  }) => (renderWrapper ? wrapper(children) : children);

  return (
    <S.ExpertAvatar className={className}>
      <Wrapper
        renderWrapper={Boolean(link)}
        wrapper={(children: React.ReactElement) => (
          <Clickable
            to={linkTo(
              'expertProfile',
              { semantic_id: link || '' },
              renderMode === 'native' ? { view: 'native' } : undefined
            )}
          >
            {children}
          </Clickable>
        )}
      >
        <>
          <UserAvatar size={size} avatar={avatar} displayName={displayName} />
          {!hideExpertIcon && <S.ExpertIcon size={size / 3} />}
        </>
      </Wrapper>
    </S.ExpertAvatar>
  );
};

export default ExpertAvatar;
